export default __webpack_public_path__ + "static/media/3.823cab23.jpg";